import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
  Typography,
} from "@mui/material";

const LocatesNotFound = ({ open, onClose, unmatchedTickers }) => {
  const theme = useTheme();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          color: theme.palette.warning.main,
          borderBottom: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Typography style={{ marginRight: "20px" }}>
          ⚠️ Unmatched Tickers
        </Typography>
      </DialogTitle>
      <DialogContent>
        <TableContainer sx={{ maxHeight: 400 }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>Ticker</TableCell>
                <TableCell align="right" sx={{ fontWeight: "bold" }}>
                  Available
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {unmatchedTickers.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item.ticker}</TableCell>
                  <TableCell align="right">{item.available}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions
        sx={{
          padding: "16px",
          borderTop: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Button onClick={onClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LocatesNotFound;
